const SvgSpringVerify = (props) => (
  <svg
    width="18"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_springverify_icon)">
      <path
        d="M8.83679 0L17.1008 3.19073C17.3952 3.30433 17.64 3.51818 17.7922 3.79463C17.9444 4.07107 17.9942 4.39236 17.9329 4.70193L17.1395 8.71434L14.4762 13.8197L9.01631 22.0919L2.3678 14.9456L8.83679 0Z"
        fill="#0828CC"
      />
      <path
        d="M8.82995 0L9.01011 22.0919L2.36532 14.9456L0.0336518 4.71502C-0.0375245 4.40335 0.00501494 4.07649 0.153593 3.79344C0.302172 3.51038 0.547005 3.28977 0.843911 3.17141L8.82995 0Z"
        fill="#0828CC"
      />
      <path
        d="M15.5981 15.576L9.04741 22.1675L3.57629 16.3421L5.34203 14.6788L9.04244 18.425L16.9599 10.0704L16.3466 14.0909C16.261 14.6527 15.999 15.1728 15.5987 15.576H15.5981Z"
        fill="#64CB8B"
      />
      <path
        d="M9.03813 16.6557V22.1649L3.57261 16.3414L3.21484 15.2368L5.24985 12.7368L9.03813 16.6557Z"
        fill="#64CB8B"
      />
      <path
        d="M2.3772 15.0034L3.53961 16.3426L4.92453 15.1624C5.02669 15.0754 5.15777 15.0299 5.29187 15.0348C5.42596 15.0398 5.55332 15.0949 5.64877 15.1893L9.03134 18.5334L16.8996 10.4854L17.2753 8.10083L9.03196 16.2385L5.65501 12.7947C5.55902 12.6967 5.42916 12.6392 5.29212 12.6342C5.15508 12.629 5.02129 12.6767 4.91829 12.7672L2.3772 15.0034Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1296 3.64517C12.1296 3.64517 7.57222 3.45815 6.20848 5.51547C5.89427 5.99713 5.68449 6.53934 5.59269 7.1071C5.55461 7.32726 5.53088 7.54967 5.52164 7.77293C5.50124 8.4216 5.57471 9.06985 5.73978 9.69746C5.83078 9.57279 5.93986 9.42311 6.07012 9.26102C6.16361 9.1407 6.2677 9.01168 6.38175 8.88019C6.49582 8.7486 6.61611 8.61144 6.73952 8.4693C6.86293 8.32716 6.99818 8.19 7.13592 8.05035C7.27741 7.91319 7.41453 7.76857 7.56411 7.63701C7.7137 7.50547 7.85705 7.36832 8.00851 7.24612L8.16931 7.11146L8.23164 7.06096L8.45602 6.89139L8.67229 6.72743L8.88729 6.58279C9.02695 6.48928 9.15658 6.3995 9.28435 6.32905L9.62653 6.12893L9.89955 5.99427L10.1364 5.87769L9.9226 6.03604L9.67885 6.21621L9.37843 6.47244C9.26627 6.56284 9.15472 6.67257 9.03501 6.78852L8.85243 6.96433L8.71593 7.11022L8.67042 7.15884L8.48344 7.35896L8.30145 7.57405C8.24473 7.63639 8.18925 7.70684 8.13378 7.77542C8.08954 7.83028 8.04528 7.88701 8.00165 7.94375L7.93932 8.02167C7.82214 8.16756 7.71619 8.32466 7.60836 8.47366L7.60026 8.48551C7.49119 8.64074 7.38959 8.79723 7.28862 8.94873C7.18766 9.10017 7.10164 9.24923 7.0175 9.39385C6.93335 9.53847 6.8567 9.67254 6.78814 9.79969C6.64977 10.0528 6.54443 10.2672 6.4765 10.4169C6.46777 10.435 6.46091 10.4499 6.45343 10.4674C7.1814 10.6911 7.94871 10.7568 8.70408 10.6601C8.91159 10.6299 9.11624 10.583 9.3161 10.5198C9.70039 10.3985 10.0611 10.2123 10.3825 9.96932C11.0162 9.40343 11.4585 8.65468 11.6485 7.82654C11.7108 7.61582 11.765 7.40074 11.8123 7.18503C12.0494 6.01948 12.1567 4.83124 12.1321 3.64206"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_springverify_icon">
        <rect width="18" height="22.1675" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgSpringVerify;
